export const generatePaymentIntentId = (length = 27) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let result = 'pi_'
  const charactersLength = characters.length
  for (let i = 0; i < length - 3; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}
